import { lazy, memo, useCallback, useContext, useEffect } from "react";
import { isMobile } from "react-device-detect";
import "react-loading-skeleton/dist/skeleton.css";
//import ApiAuth from "../../../core/api/api.auth";


const MobileFooter = lazy(() => import(/* webpackChunkName: "MobileFooter" */ "./MobileFooter"));
const DesktopFooter = lazy(() => import(/* webpackChunkName: "DesktopFooter" */ "./DesktopFooter"));

function FooterNav() {

  return (
    <footer>
      {/* ***** mobile ******************************************* */}
      {isMobile ? (
        <MobileFooter />
      ) : (
        // ***** desktop *******************************************
        <DesktopFooter />
      )}
    </footer>
  );
}
export default memo(FooterNav);

